$.urlParam = function( name ) {
    var regex = new RegExp('[?&]' + name + '=([^&#]*)'),
        results = regex.exec( location.href );
    
    if ( results ) {
        // console.log('paramGet | ' + name + ': ' + results['1'] );
        return results[1] || 0;

    } else {
        // console.log('paramGet | ' + name + ': False');
        return false;
    }
};

function init( name ) {
    $.urlParam( name );
}

module.exports = { init };